import request from 'utils/request';

export default async function findReps(manager?: string,countryCode?:any): Promise<any> {
  console.log(manager,"manger")
  try {
    let url = '/lineDriveService/territories/findReps?';

    if (manager) {
      url += `manager=${manager}&countryCode=${countryCode}`;
    }

    const { data: result } = await request(url, {
      method: 'GET',
    });

    return result;
  } catch (error) {
    console.log(error.message);
  }
}
